
import { useNavigate } from 'react-router-dom';
import { MdArrowUpward, MdArrowDownward } from 'react-icons/md';
import './StatCard.css';

const StatCard = ({ title, value, icon, trend, trendValue, color, to }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (to) {
            navigate(to);
        }
    };

    return (
        <div 
            className={`stat-card ${to ? 'clickable' : ''}`} 
            onClick={handleClick}
        >
            <div className="stat-content">
                <span className="stat-title">{title}</span>
                <span className="stat-value">{value}</span>
                {trend && (
                    <span className={`stat-trend ${trend}`}>
                        {trend === 'up' ? <MdArrowUpward /> : <MdArrowDownward />}
                        {trendValue}
                    </span>
                )}
            </div>
            <div
                className="stat-icon"
                style={{ backgroundColor: `${color}20`, color: color }}
            >
                {icon}
            </div>
        </div>
    );
};

export default StatCard;
